// Auto-generated build information - do not edit manually
// Generated at: 2026-05-18T11:33:30.859Z

export const buildInfo = {
  "buildNumber": "220-dev1779104010858",
  "buildDate": "2026-05-18T11:33:30.858Z",
  "gitCommit": "1ab7c7c",
  "gitBranch": "dev",
  "gitTag": null,
  "environment": "dev"
} as const;

export type BuildInfo = typeof buildInfo;
